"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.limit = exports.dictionariesColumns = exports.searchFields = void 0;
var i18n_1 = __importDefault(require("@/react-app/i18n"));
exports.searchFields = ['name', 'description'];
exports.dictionariesColumns = [
    { label: i18n_1.default.t('AUTOMATION.LISTS.HEADER.TITLE'), property: 'nameSort', defaultSort: 'asc' },
    { label: i18n_1.default.t('AUTOMATION.LISTS.HEADER.TYPE'), property: 'displayKind', defaultSort: 'asc' },
    { label: i18n_1.default.t('AUTOMATION.LISTS.HEADER.DATE_CREATED'), property: 'createdTime', defaultSort: 'desc' },
    { label: i18n_1.default.t('AUTOMATION.LISTS.HEADER.DATE_MODIFIED'), property: 'lastModifiedTime', defaultSort: 'desc' },
    { label: i18n_1.default.t('AUTOMATION.LISTS.HEADER.LAST_MODIFIED'), property: 'lastModifiedBy', defaultSort: 'asc' },
];
exports.limit = 50;
